import i18next from 'i18next';

i18next.addResources('es_CL', 'OrdersButtons', {
  preparing: 'En Preparación',
  prepared: 'Orden preparada',
  preparedStoreDelivery: 'Sacar a delivery',
  preparedInStore: 'Lista para retirar',
  refuseOrder: 'Rechazar pedido',
  annulOrder: 'Anular pedido',
  inProgressPickUpAction: 'Lista para retirar',
  inProgressDeliveryAction: 'Sacar a delivery',
  readyPrimaryAction: 'Rechazar pedido',
  readySecondaryAction: 'Ordenes Terminadas',
  finished: 'Orden terminada',
  inProgressSecondaryAction: 'Ordenes preparadas',
  create: 'Crear orden',
  cancelOrder: 'Anular pedido',
  moveTocreated: 'Mover a por aceptar',
  moveTopreparing: 'Mover a en preparación',
  moveToready: 'Mover a listos',
  moveTohistory: 'Mover a completados'
});

i18next.addResources('es_CR', 'OrdersButtons', {
  preparing: 'En Preparación',
  prepared: 'Orden preparada',
  preparedStoreDelivery: 'Sacar a delivery',
  preparedInStore: 'Lista para retirar',
  refuseOrder: 'Rechazar pedido',
  annulOrder: 'Anular pedido',
  inProgressPickUpAction: 'Lista para retirar',
  inProgressDeliveryAction: 'Sacar a delivery',
  readyPrimaryAction: 'Rechazar pedido',
  readySecondaryAction: 'Ordenes Terminadas',
  finished: 'Orden terminada',
  inProgressSecondaryAction: 'Ordenes preparadas',
  create: 'Crear orden',
  cancelOrder: 'Anular pedido',
  moveTocreated: 'Mover a por aceptar',
  moveTopreparing: 'Mover a en preparación',
  moveToready: 'Mover a listos',
  moveTohistory: 'Mover a completados'
});
